// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"318":"mggp-desktop-skin","426":"mggp-skin","674":"mggp-mobile-skin"}[chunkId] + ".js";
};